import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaPayload } from '@utils/typescript';
import { GetAllInsurancePolicyParams, InsurancePolicyApi } from '@apis/InsurancePolicyApi';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { insurancePolicyFetch, stateUpdate, StateUpdatePayload } from './action';

function* handleInsurancePolicyFetch({ payload }: SagaPayload<GetAllInsurancePolicyParams>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.get, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyFetch, handleInsurancePolicyFetch);
}
